import React, { useEffect, useState } from 'react';
import { fetchOfflineSettings, updateOfflineSettings } from '../../services/api';
import { ui } from '../../styles/shared';
import CollapsiblePanel from './CollapsiblePanel';

interface Props {
    onError: (message: string) => void;
}

// Standardvärden för när enheter markeras som offline.
const OfflineSettings: React.FC<Props> = ({ onError }) => {
    const [routerTimeoutHours, setRouterTimeoutHours] = useState<number>(1.5);
    const [endDeviceTimeoutHours, setEndDeviceTimeoutHours] = useState<number>(5);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const s = await fetchOfflineSettings();
                setRouterTimeoutHours(s.router_timeout_hours);
                setEndDeviceTimeoutHours(s.end_device_timeout_hours);
            } catch { /* inte kritiskt */ }
        })();
    }, []);

    const save = async () => {
        setSaving(true);
        try {
            await updateOfflineSettings({ router_timeout_hours: routerTimeoutHours, end_device_timeout_hours: endDeviceTimeoutHours });
        } catch (e: any) {
            onError(e.message || 'Kunde inte spara offline-inställningar');
        } finally {
            setSaving(false);
        }
    };

    return (
        <CollapsiblePanel title="📴 Offline-detektering (standardvärden)">
            <div>
                <label style={ui.label}>Router-timeout (timmar)</label>
                <input
                    type="number" min={0.25} step={0.25}
                    style={{ ...ui.input, width: '110px' }}
                    value={routerTimeoutHours}
                    onChange={e => setRouterTimeoutHours(Number(e.target.value))}
                />
                <div style={ui.hint}>Pluggar &amp; routrar (alltid strömförsörjda). Standard: 1,5 h</div>
            </div>
            <div>
                <label style={ui.label}>Slutenhet-timeout (timmar)</label>
                <input
                    type="number" min={0.25} step={0.25}
                    style={{ ...ui.input, width: '110px' }}
                    value={endDeviceTimeoutHours}
                    onChange={e => setEndDeviceTimeoutHours(Number(e.target.value))}
                />
                <div style={ui.hint}>Batteridrivna sensorer (EndDevice). Standard: 5 h</div>
            </div>
            <button onClick={save} disabled={saving} style={{ ...ui.btnPrimary, opacity: saving ? 0.6 : 1 }}>
                {saving ? 'Sparar…' : 'Spara'}
            </button>
            <div style={{ fontSize: '12px', color: '#666', maxWidth: '380px' }}>
                Styr när enheter markeras som offline. Enskilda enheter kan åsidosätta detta via
                inställningen <strong>offline_timeout_hours</strong> i enhetens detaljer.
            </div>
        </CollapsiblePanel>
    );
};

export default OfflineSettings;
